import React from "react";

/**
 * Lightweight per-route loading skeleton. Shown while the workflow
 * re-hydrates the authoritative calc from the backend on a hard load,
 * so clicking Next / refreshing gives a clean transition instead of a
 * blank flash or a flash of empty step content.
 */
export const StepSkeleton = () => (
  <div data-testid="step-skeleton" className="space-y-4 animate-pulse" aria-hidden="true">
    <div className="h-10 w-1/3 rounded-lg bg-slate-200 dark:bg-slate-800" />
    <div className="h-40 w-full rounded-xl bg-slate-200 dark:bg-slate-800" />
    <div className="h-24 w-full rounded-xl bg-slate-200/70 dark:bg-slate-800/70" />
    <div className="h-9 w-40 rounded-xl bg-slate-200 dark:bg-slate-800" />
  </div>
);
